import {
  Component,
  ElementRef,
  Inject,
  Injector,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  ViewEncapsulation,
  afterNextRender,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { CountrycurrencypageService } from '../countrycurrencypage.service';
import { HttpClient } from '@angular/common/http';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { environment } from 'src/environments/environment';
import { CountryListDropdown } from 'src/app/shared/components/country-dropdown/country-dropdown.component';
import { FormsModule } from '@angular/forms';
import { ToHtmlPipe } from 'src/app/shared/utilities/to-htmlpipe/to-html.pipe';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-country-currency-hero',
  templateUrl: './country-currency-hero.component.html',
  styleUrls: ['./country-currency-hero.component.scss'],
  imports: [
    CommonModule,
    CountryListDropdown,
    FormsModule,
    ToHtmlPipe,
    UrlParamsPipe
  ],
  encapsulation: ViewEncapsulation.None,
})
export class CountryCurrencyHeroComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('registerLink') registerLink: any;
  @Input() pageData: any;
  
  subscriptions: Subscription[];
  queryParams: any;
  heroData: any;
  currencies: any;
  reqBody: any;
  gbpBody: any;
  gbpChange: any;
  today = new Date();
  outAmount = 0;
  convertRate = 0;
  @ViewChild('inAmount', { static: false }) inAmount: any;
  @ViewChild('inRate', { static: true }) inRate: any;
  @ViewChild('outRate', { static: true }) outRate: any;
  currencyFrom: string = 'USD';
  currencyTo: string = '';
  isButtonEnabled: boolean = false;
  noData: boolean = false;
  selectedCountryCode1 = 'usd';
  selectedCountryCode2: string = '';
  countryCodes: any = [];
  customLabels: any = {};
  noValueErrMsg: string = '';
  isWeakToCurrency: boolean = false;

  constructor(
    private http: HttpClient,
    private countryCurrencyPageService: CountrycurrencypageService,
    private injector: Injector,
    @Inject(PLATFORM_ID) private platformId: Object,
    private route: ActivatedRoute
  ) {
    this.subscriptions = [];
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
    // Use afterNextRender for client-side only HTTP calls
    afterNextRender(() => {
      this.loadCurrencyList();
    }, { injector: this.injector });
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  ngOnInit(): void {
    // Initialization logic that works on both server and client
  }

  private loadCurrencyList(): void {
    this.http.get(environment.currencyAPIlist).subscribe((data: any) => {
      if (data != null) {
        this.currencies = data.items;
        for (let i = 0; i < this.currencies.length; i++) {
          let string = this.currencies[i]?.label || '';
          let string2 = this.currencies[i]?.label || '';
          string = string.toLowerCase();
          this.countryCodes.push(string);
          this.customLabels[string] = string2;
        }
        this.countryCodes = this.countryCodes.sort();
      }
    });
  }

  ngOnChanges(): void {
    const data = this.pageData;
    if (data != null && data?.heroContentPanel?.fields) {
      this.heroData = {
        header: data?.heroContentPanel?.fields?.title || '',
        tag: data?.heroContentPanel?.fields?.tags?.[0]?.fields?.tagText || '',
        paragraph: data?.heroContentPanel?.fields?.content || '',
        currency: data?.currency || '',
        button1: {
          text:
            data?.heroContentPanel?.fields?.buttons?.[0]?.fields?.buttonText ||
            '',
          url:
            data?.heroContentPanel?.fields?.buttons?.[0]?.fields
              ?.redirectLink || '',
          target:
            data?.heroContentPanel?.fields?.buttons?.[0]?.fields?.actionType ||
            '',
        },
        button2: {
          text:
            data?.heroContentPanel?.fields?.buttons?.[1]?.fields?.buttonText ||
            '',
          url:
            data?.heroContentPanel?.fields?.buttons?.[1]?.fields
              ?.redirectLink || '',
          target:
            data?.heroContentPanel?.fields?.buttons?.[1]?.fields?.actionType ||
            '',
        },
      };
      this.currencyTo = data?.currency || '';
      let string = data?.currency || '';
      string = string.toLowerCase();
      this.selectedCountryCode2 = string;
      
      if (this.currencyTo) {
        this.gbpBody = {
          currencyFrom: {
            label: this.currencyFrom,
          },
          currencyTo: {
            label: this.currencyTo,
          },
        };
        if (
          this.currencyFrom == this.currencyTo &&
          this.currencyFrom.toLowerCase() == 'usd'
        ) {
          this.currencyTo = 'GBP';
          this.selectedCountryCode2 = 'gbp';
        }
        
        // Only fetch currency rate on client-side
        if (isPlatformBrowser(this.platformId) && this.currencyFrom != this.currencyTo) {
          this.fetchCurrencyRate();
        }
      }
    }
  }

  private fetchCurrencyRate(): void {
    this.http.post(environment.currencyAPI, this.gbpBody).subscribe(
      data => {
        if (data != null) {
          this.gbpChange = data;
          if (this.gbpChange.rateAfterSpread > 100) {
            this.isWeakToCurrency = true;
          } else {
            this.isWeakToCurrency = false;
          }
        }
      },
      (err: any) => {}
    );
  }

  collectValue(e: any) {
    if (this.gbpChange == null || this.gbpChange == undefined) {
      this.inAmount.nativeElement.value = 0;
      this.outAmount = 0;
      return;
    }
    this.inAmount.nativeElement.value =
      !!e.target.value && Math.abs(e.target.value) >= 0
        ? Math.abs(e.target.value)
        : 0;
    let num =
      this.inAmount.nativeElement.value * this.gbpChange.rateAfterSpread;
    this.outAmount = Math.round(num * 100) / 100;
    if (this.inAmount.nativeElement.value > 0) {
      this.noValueErrMsg = '';
    } else {
      this.noValueErrMsg = 'Please enter a valid amount';
    }
  }

  getInRate() {
    this.calculateAmount(
      this.inAmount.nativeElement.value,
      this.selectedCountryCode1,
      this.selectedCountryCode2
    );
  }

  calculateAmount(enterAmount: any, incurrency: any, outcurrency: any) {
    let inRate = this.customLabels[incurrency];
    let outRate = this.customLabels[outcurrency];
    this.currencyFrom = inRate;
    this.currencyTo = outRate;
    let body = {
      currencyFrom: {
        label: inRate,
      },
      currencyTo: {
        label: outRate,
      },
    };
    if (inRate != outRate) {
      this.http.post(environment.currencyAPI, body).subscribe(
        data => {
          if (data != null) {
            this.gbpChange = data;
            if (this.gbpChange.rateAfterSpread > 100) {
              this.isWeakToCurrency = true;
            } else {
              this.isWeakToCurrency = false;
            }
            let num = enterAmount * this.gbpChange.rateAfterSpread;
            this.outAmount = Math.round(num * 100) / 100;
          }
        },
        (err: any) => {}
      );
    }
  }

  invertCurrency() {
    let inRate = this.customLabels[this.selectedCountryCode1];
    let outRate = this.customLabels[this.selectedCountryCode2];
    let x = this.selectedCountryCode1;
    let y = this.selectedCountryCode2;
    let curFrom = inRate;
    let curTo = outRate;
    this.selectedCountryCode1 = y;
    this.selectedCountryCode2 = x;
    this.currencyFrom = curTo;
    this.currencyTo = curFrom;
    this.calculateAmount(
      this.inAmount.nativeElement.value,
      this.selectedCountryCode1,
      this.selectedCountryCode2
    );
  }

  changeSelectedCountryCode1(value: string): void {
    this.selectedCountryCode1 = value;
    this.getInRate();
  }
  
  changeSelectedCountryCode2(value: string): void {
    this.selectedCountryCode2 = value;
    this.getInRate();
  }

  sendNow() {
    if (
      !this.inAmount.nativeElement.value ||
      (this.inAmount.nativeElement.value &&
        this.inAmount.nativeElement.value <= 0)
    ) {
      this.noValueErrMsg = 'Please enter a valid amount';
      return;
    } else {
      this.noValueErrMsg = '';
    }

    let url = `https://exchange.verto.co/auth/login?c1=${this.currencyFrom}&v1=1&c2=${this.currencyTo}`;
    window.open(url, '_blank');
  }
}
